<template>
    <v-container>
          <v-row class="d-flex justify-center align-center mt-sm-16 mt-lg-10 px-xl-16 overflow-auto">
            <v-col cols="12" md="8" class="d-none d-md-block mt-xl-16">
                <!-- <v-img width="200" src="../assets/logo.png" class="ml-4 px-4"></v-img> -->
                <v-img width="230" src="../assets/aums-tab-logo.png" class="ml-2 px-4 mt-xl-16"></v-img>
                <div class="mt-4 px-10 d-flex flex-column">
                    <div class="text-h2 font-weight-bold" style="color: #ca8a04 ;">Academic Unit</div>
                    <div class="text-h4 font-weight-light" style="color: #ffffff ;">Monitoring System</div>
                    <div class="text-subtitle-2 mt-2" style="color: #ffffff ;">
                        A periodically recurring task, checking progress against plans where <br> academic/unit heads conduct regular monitoring of various academic programs <br>and services implemented by Davao del Norte State College
                    </div>
                </div>
            </v-col>
            <v-col cols="12" xl="3" lg="4" md="4" sm="8" class="mt-4 mt-sm-16 mt-lg-16">
                <v-row>
                    <v-col class="d-flex flex-column justify-center align-center mb-3 d-block d-md-none">
                        <v-img width="140" src="../assets/aums-tab-logo.png" class="px-4"></v-img>
                        <div class="mt-4 px-10 d-flex flex-column">
                            <div class="text-h3 text-center font-weight-black" style="color: #ca8a04 ;">AUMS</div>
                            <div class="text-h6 text-center font-weight-light" style="color: #ffffff ;">Academic Unit Monitoring System</div>
                        </div>
                    </v-col>
                </v-row>
                <v-form ref="Formref">
                    <v-card rounded="lg" elevation="6" color="secondary" class="mt-xl-16">
                        <v-container>
                            <v-row class="mt-1 mb-2 px-4">
                                <v-col class="d-flex flex-row justify-start border-b">
                                    <div class="text-h6 font-weight-bold text-center">Welcome |&nbsp;</div>
                                    <div class="text-h6 font-weight-light text-center">Sign in</div>
                                </v-col>
                            </v-row>
                            <v-row dense class="px-2">
                                <v-col cols="12">
                                    <v-text-field
                                    v-model="email"
                                    @keydown.enter="dologin()"
                                    label="Email"
                                    :rules="[formRules.required,formRules.email, newFormRules.dnscEmail]"
                                    variant="outlined"
                                    rounded="xl"
                                    type="email"
                                    color="darkGreen"
                                    class="text-subtitle-2"
                                    >
                                    </v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field
                                    v-model="password"
                                    @keydown.enter="dologin()"
                                    label="Password"
                                    :rules="[formRules.required]"
                                    variant="outlined"
                                    rounded="xl"
                                    :append-inner-icon="showPass ? 'mdi-eye-off-outline' : 'mdi-eye-outline'"
                                    :type="showPass ? 'text' : 'password'"
                                    @click:append-inner="showPass = !showPass"
                                    class="text-subtitle-2"
                                    color="darkGreen"
                                    >
                                    </v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-btn
                                    :loading="loading"
                                    @click="dologin()"
                                    color="darkGreen"
                                    height="50px"
                                    rounded="xl"
                                    width="100%">
                                        Sign In
                                    </v-btn>
                                </v-col>
                                <v-divider class="mt-4 mb-4 mx-2"></v-divider>
                                <v-col cols="12">
                                    <v-btn
                                    @click="redirectToGoogleAuth()"
                                    prepend-icon="mdi-google"
                                    class="mb-2"
                                    color="white"
                                    height="50px"
                                    rounded="xl"
                                    width="100%">
                                        Sign in with GOOGLE
                                    </v-btn>
                                    <!-- <div class="text-caption text-center">Feature coming soon..</div> -->
                                </v-col>
                                <v-divider class="mt-4 mb-4 mx-2"></v-divider>
                                <v-col cols="12">
                                    <div class="text-subtitle-1 text-center">Don't have an account? <router-link
                                        to="/register"
                                    >Sign Up</router-link></div>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card>
                </v-form>
            </v-col>
          </v-row>
    </v-container>
</template>

<script>    
import { defineComponent } from 'vue';
import { useSnackbar } from '@/composables/useSnackbar'

export default defineComponent({
    data() {
        return {
            email: null,
            password: null,
            showPass: false,

            loading: false,
            googleAuthURL: process.env.VUE_APP_SERVER_URL + '/auth/google',

            newFormRules: {
                dnscEmail: (value) => /.+@dnsc\.edu\.ph$/.test(value) || 'Must be a DNSC Email',
            },
        }
    },
    methods: {
        async dologin() {
            const { showSnackbar } = useSnackbar()

            if (this.$refs.Formref.validate()) {
                this.loading = true
                let data = {
                    email: this.email,
                    password: this.password
                };
                let res = await this.axiosCall('/auth/login', 'post', data, false);

                if (res.data.status == 404) {
                    this.loading = false
                    showSnackbar('Email not registered')
                }
                else if (res.data.status == 409) {
                    this.loading = false
                    showSnackbar('Incorrect Password') 
                }
                else if (res.data.status == 406) {
                    this.loading = false
                    showSnackbar(`You are not verified yet to access AUMS\nNote: Please contact the admin or VPAA staff for approval`);
                }
                else if (res.data.status == 400) {
                    this.loading = false
                    showSnackbar(`Your account has been deactivated. Please contact the admin for reactivation`);
                }
                else {
                    showSnackbar('Logging in ...')

                    localStorage.setItem("aums-token", res.data.token)
                    this.$store.commit('UPDATE_EMAIL', res.data.email)
                    this.$store.commit('UPDATE_USER', res.data.user)
                    this.$store.commit('UPDATE_ROLE', res.data.user.roles[0])

                    let semesterRes = await this.axiosCall(
                        '/semester-schoolyear/getActiveSemesterSchoolYear',
                        'get',
                        null,
                        true
                    );

                    if (semesterRes && semesterRes.data) {
                        this.$store.commit('UPDATE_SEMESTER_SCHOOLYEAR', semesterRes.data)
                    }

                    this.loading = false
                    window.location.reload()
                }
            }
        },
        redirectToGoogleAuth() {
        // Redirect the user to the Google OAuth2.0 authentication URL
            window.location.href = this.googleAuthURL;
        },
    },
    async mounted() {
            const { showSnackbar } = useSnackbar()
            const token = this.$route.query.token;
            const user = this.$route.query.user;
            const error = this.$route.query.error;
            const email = this.$route.query.email;

            if (error) {
                this.loading = false;

                if (error === 'not_verified') {
                    showSnackbar(`You're not verified to access AUMS. Please contact the admin or VPAA staff for approval`);
                } else if (error === 'deactivated') {
                    showSnackbar(`Your account has been deactivated. Please contact the admin for reactivation`);
                } else if (error === 'user_not_registered') {
                    showSnackbar(`This email is not registered to AUMS. Please register`);
                }
                return;
            }

            if (!token || !user) {
                return;
            }

            this.loading = true;
            showSnackbar('Logging in ...');

            localStorage.setItem('aums-token', token);

            const parsedUser = JSON.parse(user);

            this.$store.commit('UPDATE_USER', parsedUser);
            if (parsedUser.roles && parsedUser.roles.length > 0) {
                this.$store.commit('UPDATE_ROLE', parsedUser.roles[0]);
            }
            this.$store.commit('UPDATE_EMAIL', email);

            const semesterRes = await this.axiosCall(
                '/semester-schoolyear/getActiveSemesterSchoolYear',
                'get',
                null,
                true 
            );

            if (semesterRes?.data) {
                this.$store.commit('UPDATE_SEMESTER_SCHOOLYEAR', semesterRes.data);
            }

            this.loading = false;
            window.location.reload();
        }
    })
</script>

<style  scoped>
@media (max-width: 767px) {
  .blur {
    display: none;
  }
}

@media (min-width: 767px) {
  .unblur {
    display: block;
 }
}
</style>